import { useEffect } from 'react'
import { business } from '../data/site'

type Seo = {
  title: string
  description: string
  lang: string
}

function setMeta(attr: 'name' | 'property', key: string, content: string) {
  let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`)
  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute(attr, key)
    document.head.appendChild(tag)
  }
  tag.setAttribute('content', content)
}

function setBusinessSchema(description: string, lang: string) {
  const id = 'ld-local-business'
  let script = document.getElementById(id) as HTMLScriptElement | null
  if (!script) {
    script = document.createElement('script')
    script.id = id
    script.type = 'application/ld+json'
    document.head.appendChild(script)
  }
  script.textContent = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'Florist',
    name: business.name,
    description,
    inLanguage: lang,
    telephone: '+1-240-413-8201',
    email: business.email,
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Jessup',
      addressRegion: 'MD',
      postalCode: '20794',
      addressCountry: 'US',
    },
    areaServed: [
      'Jessup, MD',
      'Columbia, MD',
      'Laurel, MD',
      'Elkridge, MD',
      'Howard County, MD',
      'Anne Arundel County, MD',
      "Prince George's County, MD",
    ],
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        opens: '09:00',
        closes: '19:00',
      },
    ],
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: business.rating.toFixed(1),
      reviewCount: business.reviewCount,
    },
    knowsLanguage: ['en', 'es'],
  })
}

export function useSeo({ title, description, lang }: Seo) {
  useEffect(() => {
    document.title = title
    setMeta('name', 'description', description)
    setMeta('property', 'og:title', title)
    setMeta('property', 'og:description', description)
    setMeta('property', 'og:type', 'website')
    setBusinessSchema(description, lang)
  }, [title, description, lang])
}
